/**
 * 表示整形。
 * 数値の見せ方をここに集約し、画面ごとに桁の扱いがぶれないようにする。
 */

/** 工数。小数第 1 位まで、末尾の 0 は落とす。 */
export function hours(value: number): string {
  return `${Number(value.toFixed(1))} h`;
}

/** 工数。単位を省いた数字だけ。列幅の限られたグリッドのセルで使う。 */
export function hoursNum(value: number): string {
  return String(Number(value.toFixed(1)));
}

/** 金額。百万円を超えたら M 表記に丸める (デザインの数値タイルに合わせる)。 */
export function yen(value: number): string {
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);
  if (abs >= 1_000_000) return `${sign}¥ ${Number((abs / 1_000_000).toFixed(1))}M`;
  return `${sign}¥ ${abs.toLocaleString('ja-JP')}`;
}

/** 金額。CSV や明細で使う丸めなしの表記。 */
export function yenExact(value: number): string {
  return `¥${value.toLocaleString('ja-JP')}`;
}

export function percent(value: number | null): string {
  return value === null ? '—' : `${Number(value.toFixed(1))}%`;
}

/** '2026-08' -> '2026年8月' */
export function monthLabel(month: string): string {
  const [year, mon] = month.split('-');
  return `${year}年${Number(mon)}月`;
}

/** 前月・翌月 */
export function shiftMonth(month: string, delta: number): string {
  const [year, mon] = month.split('-').map(Number) as [number, number];
  const date = new Date(Date.UTC(year, mon - 1 + delta, 1));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
}

/** ブラウザのローカル日付から当月を求める */
export function currentMonth(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}
